var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showInstallLink && _vm.deferredPrompt)?_c('li',{on:{"click":_vm.installPwa}},[_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"onclick":"event.preventDefault();return false;"}},[_vm._v(_vm._s(_vm.$t("message['Installer l application']")))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }